import React from 'react';
import { format } from '@querodelivery/qd-date-helper';

import styles from './styles.module.scss';

import WhatsappNumber from '../../WhatsappNumber/WhatsappNumber';
import { cnpjLabel, cpfLabel } from '@/Utils/FnUtils';
import useAddressModal from '@/hooks/address/useAddressModal';
import type { Place } from '@/_types/places';
import { useCities } from '@/_hooks/use-cities';

interface Props {
  place: Place;
}

function PlaceInfo({ place }: Props) {
  const { showAddressModal } = useAddressModal();
  const { getCityInfo } = useCities();

  const cityInfo = getCityInfo(place.municipioId);

  return (
    <div className={styles.infoContainer}>
      <h2 className="mgn-bottom-sm">Informações</h2>

      <div className={styles.containerInfoPlaceDetalhes}>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Criado em </strong>
          <span>{format(new Date(place.createdAt), 'dd/MM/yyyy')}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Celular </strong>
          <WhatsappNumber number={place.celular} />
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Email </strong>
          <span>{place.email}</span>
        </div>
        {place.cnpj && (
          <div className={styles.infoPlaceDetalhes}>
            <strong>CNPJ </strong>
            <span>{cnpjLabel(place.cnpj)}</span>
          </div>
        )}
        {place.cpf && (
          <div className={styles.infoPlaceDetalhes}>
            <strong>CPF </strong>
            <span>{cpfLabel(place.cpf)}</span>
          </div>
        )}
        <div>
          <div className={styles.infoPlaceDetalhes}>
            <strong>Localização </strong>
            <span>
              <a
                onClick={() =>
                  showAddressModal({
                    address: place.endereco,
                    location: place.localizacao,
                  })
                }
              >
                Abrir
              </a>
            </span>
          </div>
        </div>

        <div className={styles.infoPlaceDetalhes}>
          <strong>Cidade </strong>
          <span>{`${cityInfo?.nome} - ${cityInfo?.uf}`}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Logradouro </strong>
          <span>{place.endereco.logradouro}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Número </strong>
          <span>{place.endereco.numero}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Bairro </strong>
          <span>{place.endereco.bairro}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>CEP </strong>
          <span>{place.endereco.cep}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Complemento </strong>
          <span>{place.endereco.complemento}</span>
        </div>
        <div className={styles.infoPlaceDetalhes}>
          <strong>Referência </strong>
          <span>{place.endereco.referencia}</span>
        </div>
      </div>
    </div>
  );
}

export default PlaceInfo;
